export default class EmailOptionApplication {
  init() {
    const sendButton = $('#mfa_send_button');
    if (sendButton) {
      sendButton.on('click', (event) => {
        this.toggleCodeSend(event);
      });
    }
  }

  toggleCodeSend = (event) => {
    const sendButton = event.target;
    const codeFields = $('#code_fields');
    const initialMessage = $('#initial_message');
    const hotpKey = $('#email_setup_hotp_key').val();

    window.serverClient.customRequest(gon.auth_code_path, 'POST', {
      hotp_key: hotpKey,
      skipCsrfTokenRefresh: true
    }).done(() => {
      sendButton.innerText = 'Request Another Code';
      sendButton.classList = 'btn btn-link';
      codeFields.show();
      initialMessage.hide();
    });
  }
}
